import { formatMoneyVN } from "@app/utils/util";

export interface WanInfo {
  /** chuỗi gốc trong ssh.router / ssh.router_xoay, gửi lên API nguyên như bản cũ */
  raw: string;
  /** WAN1 */
  code: string;
  /** VNPT, VIETTEL (sử dụng 24h)... */
  isp: string;
  /** số tiền, null nếu chuỗi không có giá */
  price: number | null;
}

/**
 * Tách 1 mục đường truyền chỉ để hiển thị, ví dụ "WAN1 - VNPT - 3000 VNĐ", "wan1 - vnpt - 1000 đ",
 * "WAN00-MẶC ĐỊNH-0 Đ". Phần cuối có chữ số là giá (API cũng lấy giá ở phần thứ 3).
 */
export const parseWan = (raw: string): WanInfo => {
  const parts = raw
    .split("-")
    .map((part) => part.trim())
    .filter(Boolean);
  const last = parts[parts.length - 1] || "";
  const hasPrice = parts.length > 1 && /^\d[\d.,]*\s*(đ|vn|$)/i.test(last);
  const isp = parts.slice(1, hasPrice ? -1 : undefined).join(" - ");

  return {
    raw,
    code: (parts[0] || raw.trim()).toUpperCase(),
    isp,
    price: hasPrice ? Number(last.split(/\s/)[0].replace(/[.,]/g, "")) || 0 : null,
  };
};

/** Các mục của ssh.router / ssh.router_xoay (ngăn cách bằng dấu phẩy) */
export const splitWans = (router?: string) =>
  (router || "")
    .split(",")
    .filter((wan) => wan.trim())
    .map(parseWan);

export const wanPriceText = (price: number | null) =>
  price === null ? "" : price ? `${formatMoneyVN(price)} VNĐ` : "Miễn phí";

/** Nhà mạng gom theo chữ hoa để "vnpt" và "VNPT" là 1 nhóm */
export const ispKey = (isp: string) => isp.toUpperCase();

export const ispClass = (isp: string) =>
  /vnpt/i.test(isp) ? "bg-brand-soft text-brand" : /viettel/i.test(isp) ? "bg-bad-soft text-bad" : "bg-surface-2 text-muted";
